var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BaseWeb-layout"},[_c('BgContainer',{on:{"onDownload":_vm.onDownload}}),_c('Fotet',{on:{"onDownload":_vm.onDownload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }